import { render, staticRenderFns } from "./UbiCorporal.vue?vue&type=template&id=28af0c6d"
import script from "./UbiCorporal.vue?vue&type=script&lang=ts"
export * from "./UbiCorporal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports